import { apiRequest } from "./client";

/**
 * Pilot launch ops (Sprint 10, Part 90 §90.1-§90.2). OWNER-only,
 * cross-org read views: day-0 ops summary + north-star funnel.
 */

export const adminApi = {
  async opsSummary() {
    return apiRequest("/api/admin/ops-summary");
  },

  async funnel() {
    return apiRequest("/api/admin/funnel");
  },
};
